import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import Image from '../Image';
import theme from '../theme';

export interface ListingImageProps {
  size: number;
  thumbnail?: string;
}

const ListingImage: React.FC<ListingImageProps> = ({ size, thumbnail }) => (
    <StyledImageContainer>
      <StyledImage
        size={size}
        src={thumbnail}
        preview={false}
        placeholder={<Icon type="antdHomeFilled" />}
      />
    </StyledImageContainer>
  );

export default React.memo(ListingImage);

const StyledImageContainer = styled.div`
  display: flex;

  & .ant-image-placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.gray5};
    border-radius: ${theme.getBorderRadius('medium')};
  }
`;

// @TODO APP-5718: See if Thumbnail component can be used here when adding skeletons
const StyledImage = styled(Image).attrs<{ size: number }>(props => ({
  width: props.size,
  height: props.size,
}))<{ size: number }>`
  object-fit: cover;
  border-radius: ${theme.getBorderRadius('medium')};
`;
